import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap,catchError, tap, take } from 'rxjs/operators';
import { InvitationClient, InvitationUrlDetailsDto } from 'src/app/api/portal-api.generated';
import { AppSettingsService } from 'src/app/shared/services/app-settings/app-settings.service';
import { SidebarService } from 'src/app/containers/layout/sidebar/sidebar.service';
import { ApplicationFeatures, ApplicationRouteSegments } from 'src/app/shared/enums/enums';
import {LocalStorageService} from '../../../../shared/services/storage/local-storage/local-storage.service';
import {REDIRECT} from '../../../../shared/constants/value';
@Component({
  selector: 'app-invitation',
  templateUrl: './invitation.component.html',
  styleUrls: ['./invitation.component.scss']
})
export class InvitationComponent implements OnInit {
  public invitationUrlDetails$: Observable<InvitationUrlDetailsDto> = this.route.paramMap
  .pipe(
    switchMap((params: ParamMap) => {
      const id: string = params.get('id');

      return this.invitationClient.getInvitationUrlDetails(id);
    }),
    catchError((e) => of({})
    ));

  public changeToAuthIfV3$ = this.route.paramMap.pipe(tap(
    (params: ParamMap) => {
      const id: string = params.get('id');
      if (!AppSettingsService.disabledFeatures.find((x) => x === ApplicationFeatures.invitationLinksV3)) {
        window.location.href = `${AppSettingsService.authServiceUrl}/Account/Register?invitationId=${id}`;
      }
    }
  ));

  constructor(
    private readonly route: ActivatedRoute,
    private readonly invitationClient: InvitationClient,
    private readonly sidebarService: SidebarService,
    private localStorageService: LocalStorageService,
  ) { }

  ngOnInit(): void {
    this.changeToAuthIfV3$.pipe(take(1)).subscribe();
    this.collapsSidebarMenu();
  }

  collapsSidebarMenu() {
    setTimeout(() => {
      this.sidebarService.collapse(true);
    }, 100);
  }

  createMerchantProfile(id: string): void {
    const { origin } = window.location;

    this.localStorageService.remove(REDIRECT);

    window.location.href = `${AppSettingsService.authServiceUrl}/Account/Register?invitationId=${id}&ReturnUrl=${origin}/${
      ApplicationRouteSegments.onboarding}/${ApplicationRouteSegments.business}/${ApplicationRouteSegments.createProfile}`;

  }


}
